<template>
  <div :class="$style.title">Сотрудники контрагента</div>
  <div :class="$style.row">
    <div :class="$style.headers">
      <div :class="$style.column">ФИО</div>
      <div :class="$style.column">Должность</div>
      <div :class="$style.column">Рабочий телефон</div>
      <div :class="$style.column">Личный телефон</div>
      <div :class="$style.column">E-mail</div>
      <div :class="$style.column">Примечание</div>
    </div>
  </div>

  <template v-if="employes.length">
    <div
      v-for="employe in employes"
      :key="employe.full_name"
      :class="[$style.row, $style.employes]"
    >
      <div :class="$style.headers">
        <div :class="[$style.column, $style.field]">
          {{ employe.full_name }}
        </div>
        <div :class="[$style.column, $style.field]">{{ employe.position }}</div>
        <div :class="[$style.column, $style.field]">
          {{ employe.work_phone }}
        </div>
        <div :class="[$style.column, $style.field]">
          {{ employe.personal_phone }}
        </div>
        <div :class="[$style.column, $style.field]">{{ employe.email }}</div>
        <div :class="[$style.column, $style.field]">{{ employe.note }}</div>
      </div>
      <img
        v-if="!readonly"
        @click="remove(employe.full_name)"
        src="/icons/delete.svg"
        alt=""
      />
    </div>
  </template>

  <div v-if="!readonly" :class="$style.row">
    <div :class="$style.headers">
      <div :class="[$style.column, { [$style.error]: errors.full_name }]">
        <input
          v-model="form.full_name"
          @focus="errors.full_name = false"
          type="text"
          placeholder="Введите ФИО"
        />
      </div>
      <div :class="$style.column">
        <input
          v-model="form.position"
          type="text"
          placeholder="Введите должность"
        />
      </div>
      <div :class="[$style.column, { [$style.error]: errors.work_phone }]">
        <input
          v-model="form.work_phone"
          @focus="errors.work_phone = false"
          type="text"
          placeholder="Введите раб. телефон"
        />
      </div>
      <div :class="[$style.column, { [$style.error]: errors.personal_phone }]">
        <input
          v-model="form.personal_phone"
          @focus="errors.personal_phone = false"
          type="text"
          placeholder="Введите лич. телефон"
        />
      </div>
      <div :class="[$style.column, { [$style.error]: errors.email }]">
        <input
          v-model="form.email"
          @focus="errors.email = false"
          type="text"
          placeholder="Введите e-mail"
        />
      </div>
      <div :class="$style.column">
        <input
          v-model="form.note"
          type="text"
          placeholder="Введите примечание"
        />
      </div>
    </div>
    <img
      @click="resetForm"
      :class="{ [$style.disabled]: disabled }"
      src="/icons/delete.svg"
      alt=""
    />
  </div>

  <div v-if="!readonly" :class="$style.add">
    <div @click="add" :class="$style.button">Добавить сотрудника</div>
  </div>
</template>

<script>
import { validatePhoneNumber } from "@/utils/validate-phone.js";
import { validateEmail } from "@/utils/validate-email.js";
export default {
  data() {
    return {
      form: {
        full_name: "",
        position: "",
        work_phone: "",
        personal_phone: "",
        email: "",
        note: "",
      },
      errors: {
        full_name: false,
        work_phone: false,
        personal_phone: false,
        email: false,
      },
    };
  },
  props: {
    itemEmployes: Array,
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    add() {
      if (!this.validate()) {
        return;
      }

      let value = JSON.parse(JSON.stringify(this.employes));
      value.push(JSON.parse(JSON.stringify(this.form)));
      this.$store.commit("setCounterpartiesField", {
        field: "counterparty_contacts",
        value: value,
      });
      this.resetForm();
    },
    remove(fio) {
      let value = JSON.parse(JSON.stringify(this.employes));
      value = value.filter((i) => i.full_name !== fio);
      this.$store.commit("setCounterpartiesField", {
        field: "counterparty_contacts",
        value: value,
      });
    },
    resetForm() {
      for (let key in this.form) {
        this.form[key] = "";
      }
      for (let key in this.errors) {
        this.errors[key] = false;
      }
    },
    validate() {
      let resp = true;
      if (!this.form.full_name) {
        this.errors.full_name = true;
        resp = false;
      }
      if (this.form.work_phone && !validatePhoneNumber(this.form.work_phone)) {
        this.errors.work_phone = true;
        resp = false;
      }
      if (
        this.form.personal_phone &&
        !validatePhoneNumber(this.form.personal_phone)
      ) {
        this.errors.personal_phone = true;
        resp = false;
      }
      if (this.form.email && !validateEmail(this.form.email)) {
        this.errors.email = true;
        resp = false;
      }
      return resp;
    },
  },
  computed: {
    counterpartie() {
      return this.$store.state.counterparties.counterpartie;
    },
    employes() {
      return this.readonly
        ? this.itemEmployes
        : this.$store.state.counterparties.counterpartie.counterparty_contacts;
    },
    disabled() {
      let resp = true;
      for (let key in this.form) {
        if (this.form[key]) {
          resp = false;
        }
      }
      return resp;
    },
    allErrors() {
      return this.$store.state.errors.errors[0];
    },
  },
};
</script>

<style lang="scss" module>
.title {
  @include Subtitle;
  margin: 1.5rem 0 1rem 0;
}
.row {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin: 0 0 1rem 0;
  &.employes {
    margin: 0 0 0.25rem 0;
  }
  img {
    cursor: pointer;
    &.disabled {
      opacity: 0;
      cursor: auto;
      pointer-events: none;
    }
  }
}
.headers {
  flex: 1 1 auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  gap: 0.25rem;
  @include Subtitle;
  .column {
    &.error {
      border: 1px solid $red-primary;
      border-radius: 0.25rem;
    }
    input {
      width: 100%;
      padding: 0.75rem 1rem;
      border-radius: 0.25rem;
      background-color: $bg-secondary;
      outline: 0;
      border: none;
      @include Body1;
      &::placeholder {
        @include Body1;
        color: $t-secondary;
      }
    }
    &.field {
      padding: 0.75rem 1rem;
      border-radius: 0.25rem;
      @include Body1;
      background-color: $bg-secondary;
    }
  }
}
.add {
  display: flex;
  justify-content: flex-end;
  margin: 0 2.5rem 0 0;
  .button {
    padding: 0.5rem 0.75rem;
    border-radius: 6.25rem;
    @include Body1;
    cursor: pointer;
    color: $t-white;
    background-color: $main-green;
    border: 1px solid $main-green;
  }
}
</style>
